/** Spacing scale — verbatim from source --sp-* tokens (4px base). */
export const spacing = {
  s1: 4,
  s2: 8,
  s3: 12,
  s4: 16,
  s5: 20,
  s6: 24,
  s8: 32,
} as const;

export type Spacing = typeof spacing;
